export const LogoMark = ({ className = "h-10" }) => (
  <svg viewBox="0 0 84 96" fill="none" className={className} aria-hidden="true">
    <path d="M20.8 18.8 A30 30 0 0 1 63.2 18.8" stroke="#2E4FA8" strokeWidth="9" strokeLinecap="round" />
    <path d="M28.6 26.6 A19 19 0 0 1 55.4 26.6" stroke="#4A6BC5" strokeWidth="9" strokeLinecap="round" />
    <path d="M36 34 A8.5 8.5 0 0 1 48 34" stroke="#4FC3E8" strokeWidth="8" strokeLinecap="round" />
    <circle cx="42" cy="40" r="5.5" fill="#4FC3E8" />
    <path d="M28 62 V56 A14 14 0 0 1 56 56 V62" stroke="#3B5BA5" strokeWidth="9" strokeLinecap="round" />
    <rect x="24" y="62" width="36" height="30" rx="8" fill="#3B5BA5" />
    <circle cx="42" cy="74" r="5" fill="#14204A" />
    <path d="M38.5 77 H45.5 L47.5 87 H36.5 Z" fill="#14204A" />
  </svg>
);

const Globe = () => (
  <g>
    <circle cx="172" cy="52" r="21" fill="#F5854E" stroke="#1B2A55" strokeWidth="3" />
    <ellipse cx="172" cy="52" rx="10" ry="21" fill="none" stroke="#1B2A55" strokeWidth="3" />
    <path d="M145 52 H199" stroke="#1B2A55" strokeWidth="3" />
    <path d="M147.6 42 H186.4" stroke="#1B2A55" strokeWidth="3" />
    <path d="M147.6 62 H186.4" stroke="#1B2A55" strokeWidth="3" />
  </g>
);

const Wordmark = ({ tagline }) => (
  <g>
    <text x="94" y="70" fill="#F5854E" fontFamily="'Baloo 2', sans-serif" fontWeight="800" fontSize="54">
      Pr
    </text>
    <Globe />
    <text x="196" y="70" fill="#F5854E" fontFamily="'Baloo 2', sans-serif" fontWeight="800" fontSize="54">
      net
    </text>
    <rect x="94" y="80" width="190" height="7" rx="3.5" fill="#F5854E" />
    {tagline && (
      <text
        x="94"
        y="104"
        fill="#5B7BC9"
        fontFamily="'Baloo 2', sans-serif"
        fontWeight="700"
        fontSize="13"
        letterSpacing="2.5"
      >
        SMART NETWORKING SOLUTIONS
      </text>
    )}
  </g>
);

export default function Logo({ onClick }) {
  return (
    <a
      href="#top"
      onClick={(e) => {
        e.preventDefault();
        if (onClick) onClick();
      }}
      data-testid="logo-link"
      className="group flex items-center"
      aria-label="PRONET home"
    >
      <svg viewBox="0 0 300 100" className="h-12 w-auto sm:h-14" role="img" aria-label="PRONET — Smart Networking Solutions">
        <g className="transition-transform duration-300 group-hover:rotate-[4deg]" style={{ transformOrigin: "42px 48px" }}>
          <path d="M20.8 18.8 A30 30 0 0 1 63.2 18.8" stroke="#2E4FA8" strokeWidth="9" strokeLinecap="round" fill="none" />
          <path d="M28.6 26.6 A19 19 0 0 1 55.4 26.6" stroke="#4A6BC5" strokeWidth="9" strokeLinecap="round" fill="none" />
          <path d="M36 34 A8.5 8.5 0 0 1 48 34" stroke="#4FC3E8" strokeWidth="8" strokeLinecap="round" fill="none" />
          <circle cx="42" cy="40" r="5.5" fill="#4FC3E8" />
          <path d="M28 62 V56 A14 14 0 0 1 56 56 V62" stroke="#3B5BA5" strokeWidth="9" strokeLinecap="round" fill="none" />
          <rect x="24" y="62" width="36" height="30" rx="8" fill="#3B5BA5" />
          <circle cx="42" cy="74" r="5" fill="#0B1220" />
          <path d="M38.5 77 H45.5 L47.5 87 H36.5 Z" fill="#0B1220" />
        </g>
        <Wordmark />
      </svg>
    </a>
  );
}

export function LogoFull({ className = "h-12" }) {
  return (
    <svg viewBox="0 0 300 116" className={className} role="img" aria-label="PRONET — Smart Networking Solutions">
      <path d="M20.8 18.8 A30 30 0 0 1 63.2 18.8" stroke="#2E4FA8" strokeWidth="9" strokeLinecap="round" fill="none" />
      <path d="M28.6 26.6 A19 19 0 0 1 55.4 26.6" stroke="#4A6BC5" strokeWidth="9" strokeLinecap="round" fill="none" />
      <path d="M36 34 A8.5 8.5 0 0 1 48 34" stroke="#4FC3E8" strokeWidth="8" strokeLinecap="round" fill="none" />
      <circle cx="42" cy="40" r="5.5" fill="#4FC3E8" />
      <path d="M28 62 V56 A14 14 0 0 1 56 56 V62" stroke="#3B5BA5" strokeWidth="9" strokeLinecap="round" fill="none" />
      <rect x="24" y="62" width="36" height="30" rx="8" fill="#3B5BA5" />
      <circle cx="42" cy="74" r="5" fill="#0B1220" />
      <path d="M38.5 77 H45.5 L47.5 87 H36.5 Z" fill="#0B1220" />
      <Wordmark tagline />
    </svg>
  );
}
